// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"18742503","582":"18742503","707":"18742503","805":"18742503"}[chunkId] + ".chunk.css";
};